import React from "react";
import { AddAdminContextProvider } from "./AddAdminView";
import AddAdminPage from "./views/AddAdminPage";

const AddAdmin = () => {
  return (
    <div>
      <AddAdminContextProvider>
        <AddAdminPage />
      </AddAdminContextProvider>
    </div>
  );
};

export default AddAdmin;
